import React from 'react';
import HoneycombTracer from '../../honeycomb/tracer';

export default class ErrorBoundaryWidgetContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };

    this.honeycombTracer = new HoneycombTracer();
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { widgetComponentName } = this.props;

    this.honeycombTracer.startActiveSpan('WidgetError', (span) => {
      span.setAttribute('widget.component', widgetComponentName);
      span.setAttribute('widget.renderingError', error.toString());
      span.setAttribute('widget.renderingErrorInfo', errorInfo.componentStack);

      span.end();
    });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <div />;
    }

    return children;
  }
}
